﻿export enum HTMLTooltipTypes {
  bankStatement = 1,
  photoID = 2,
  loanSummary = 3,
  payStub = 4,
  W2 = 5,
  propertyType = 6,
  purchaseDocuments = 7,
  militaryServiceMembers = 8,
  maritalStatus = 9,
  coBorrower = 10,
  verifyCreditHistory = 11,
  creditScore = 12,
  downPayment = 13,
  creditAuthorization = 14,
  propertyTax = 15,
  vaFundingFees = 16,
  refinanceGoals = 17,
  propertyPurpose = 18,
  monthlyMortgagePayment = 19,
  VAFixedRate = 20,
  ConventionalFixedRate = 21,
  offerDetailsRate = 22,
  offerDetailsAPR = 23,
  offerDetailsPoints = 24,
  offerDetailsCashToClose = 25,
  offerDetailsNewLoanAmount = 26,
  loanYouSelectedRateLock = 27,
  homeownersAssociation = 28,
  voidedCheck = 29,
  verifyAssets = 30,
  manufacturedHomePropertyType = 31,
  manufacturedHomeOwnership = 32
}
